import { FormItemProps, Col, Form } from "antd";
import { StepsForm } from "@components/Steps/Form";
import { ReactNode } from "react";
import { FormFieldDisplay } from "./FormFieldDisplay";

export type FormFieldProps = FormItemProps & {
  FormItemComponent?: typeof Form.Item;
  displayOnly?: boolean;
  displayFormatter?: (value?: string | number | null) => ReactNode;
};

export const FormField = (props: FormFieldProps) => {
  const {
    FormItemComponent = Form.Item,
    wrapperCol,
    displayOnly,
    displayFormatter,
    children,
    ...formItemProps
  } = props;

  return (
    <Col {...wrapperCol}>
      {displayOnly && typeof children !== "function" ? (
        <FormItemComponent {...formItemProps} valuePropName="value">
          <FormFieldDisplay format={displayFormatter}>
            {children}
          </FormFieldDisplay>
        </FormItemComponent>
      ) : (
        <FormItemComponent {...formItemProps}>{children}</FormItemComponent>
      )}
    </Col>
  );
};

export const StepsFormField = (props: FormFieldProps) => (
  <FormField FormItemComponent={StepsForm.Item} {...props} />
);
